module.exports = __webpack_public_path__ + "static/media/ai-synonyms-banner.d61cc09b.png";